import React from 'react';
import { FiAlertCircle, FiArrowRight, FiClock } from 'react-icons/fi';
import '../styles/trial-banner.css';

function formatTrialDate(value) {
  if (!value) return 'N/A';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return 'N/A';
  return parsed.toLocaleString();
}

export default function TrialBanner({ trial, compact = false, onViewPricing }) {
  if (!trial || !trial.isTrialUser) {
    return null;
  }

  const isActive = !!trial.isTrialActive;
  const line =
    trial.trialBannerLine ||
    (isActive
      ? `TRIAL ACTIVE${
          Number.isFinite(trial?.trialDaysRemaining)
            ? ` — ${trial.trialDaysRemaining} day${trial.trialDaysRemaining === 1 ? '' : 's'} remaining`
            : ''
        }`
      : 'TRIAL ENDED');

  const subtitle = isActive
    ? `Full access to chat and admin features during your trial. Trial ends: ${formatTrialDate(trial.trialEndsAt)}.`
    : 'Your 3-day trial has ended. Upgrade to continue chat and admin access.';

  const handlePricing = () => {
    if (typeof onViewPricing === 'function') {
      onViewPricing();
      return;
    }
    const base = (import.meta.env.VITE_BASE_PATH || '').replace(/\/$/, '');
    window.location.assign(`${window.location.origin}${base || ''}/#pricing`);
  };

  return (
    <div
      className={`trial-banner ${isActive ? 'active' : 'expired'} ${compact ? 'compact' : ''}`}
      role={isActive ? 'status' : 'alert'}
    >
      <span className="trial-banner-icon" aria-hidden="true">
        {isActive ? <FiClock /> : <FiAlertCircle />}
      </span>
      <div className="trial-banner-copy">
        <strong>{line}</strong>
        <span>{subtitle}</span>
      </div>
      {!isActive && (
        <button type="button" className="trial-banner-cta" onClick={handlePricing}>
          <span>View pricing</span>
          <FiArrowRight aria-hidden="true" />
        </button>
      )}
    </div>
  );
}
